import { adjustmentService } from '@/services';
import AdjustmentWorkerVM from '@/view-model/worker-adjustment/AdjustmentWorkerVM';
export default {
    async getDetailsPerWorkerList({ commit }) {
        const res = await adjustmentService.getDetailsPerWorkerList();
        res.list = res.list.map((worker) => new AdjustmentWorkerVM(worker));
        commit('GET_DETAILS_PER_WORKER_LIST', res.list);
        return res;
    },
};
